if ( typeof gsap !== 'undefined' ) {
	const lists = document.querySelectorAll( '.numbers-carousel__list' );

	function calculateTotalWidth( items ) {
		return Array.from( items ).reduce( ( total, item ) => total + item.offsetWidth, 0 );
	}

	function duplicateItems( container, items ) {
		items.forEach( ( item ) => container.appendChild( item.cloneNode( true ) ) );
	}

	function animateCarousel( list, direction, duration ) {
		if ( ! list ) return;

		const items = list.querySelectorAll( '.numbers-carousel__item' );
		if ( items.length === 0 ) return;

		const totalWidth = calculateTotalWidth( items );
		duplicateItems( list, items );

		const tl = gsap.timeline( { repeat: -1 } );

		if ( direction === 'left' ) {
			tl.to( list, { x: -totalWidth, duration, ease: 'none' } );
			tl.set( list, { x: 0 } );
		} else {
			tl.set( list, { x: -totalWidth } );
			tl.to( list, { x: 0, duration, ease: 'none' } );
			tl.set( list, { x: -totalWidth } );
		}
	}

	lists.forEach( ( list ) => {
		const carousel = list.closest( '.numbers-carousel' );
		if ( carousel ) {
			const direction = carousel.getAttribute( 'data-direction' ) || 'right';
			animateCarousel( list, direction, 30 );
		}
	} );
}

